'use client';

import { useEffect } from 'react';

type BootWatchWindow = Window & {
  __ppcCancelBootWatch?: () => void;
  __ppcMarkContentReady?: () => void;
};

const PUBLIC_ROUTE_PREFIXES = ['/login', '/privacy'];

function isImmediateContentReadyRoute(pathname: string): boolean {
  if (!pathname || pathname === '/') return true;
  for (const prefix of PUBLIC_ROUTE_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) return true;
  }
  return false;
}

const NATIVE_RECOVERY_LEVEL_KEY = 'ppc_native_recovery_level';

export function BootStatusInit() {
  useEffect(() => {
    if (typeof document !== 'undefined' && document.body) {
      document.body.dataset.appMounted = '1';
    }
    try {
      localStorage.removeItem(NATIVE_RECOVERY_LEVEL_KEY);
    } catch {
      /* ignore */
    }
    const win = window as BootWatchWindow;
    win.__ppcCancelBootWatch?.();

    // Public routes (login/privacy/root) never show the bootstrap spinner from
    // (main)/layout.tsx, so we can flip the "content ready" flag immediately.
    // Protected routes call this themselves once their bootstrap completes.
    if (typeof window !== 'undefined' && isImmediateContentReadyRoute(window.location.pathname)) {
      win.__ppcMarkContentReady?.();
    }
  }, []);

  return null;
}
